import type { FromBaseRow as Row } from './from-base-context';
import type { FormulaVariableReaders } from './formula-variable-resolution';

/** Native relocation on a constructed, locally owned creature. */
export function relocateCreatureDerivedToComputed(host: Row, readers: FormulaVariableReaders): void {
    const creature = (host.computed as Row).creature as Row, equipped: Row = {};
    for (const key of ['count_main_hand_equipped', 'count_off_hand_equipped', 'count_both_hands_equipped',
        'count_main_hand_weapon_equipped', 'count_off_hand_weapon_equipped', 'count_both_hands_weapon_equipped',
        'count_head_weapon_equipped', 'count_armor_equipped', 'count_shield_equipped',
        'count_main_hand_natural_weapon_equipped', 'count_off_hand_natural_weapon_equipped',
        'equipped_main_hand_natural_weapon_item_id', 'equipped_off_hand_natural_weapon_item_id',
        'equipped_armor_inventory_id', 'equipped_armor_inventory_item_id', 'equipped_shield_inventory_id', 'equipped_shield_inventory_item_id']) {
        if (!Object.prototype.hasOwnProperty.call(host, key)) continue;
        const value = readers.layerValue(host, key);
        if (value !== null && value !== '' && value !== 0 && value !== '0') equipped[key] = value;
        delete host[key];
    }
    if (Object.keys(equipped).length) creature.equipped = equipped;
    for (const key of ['total_weight_held', 'gross_weight']) if (Object.prototype.hasOwnProperty.call(host, key)) {
        creature.weight ??= {};
        (creature.weight as Row)[key] = readers.itemField({ [key]: [host[key]] }, key);
        delete host[key];
    }
    for (const key of ['derivative_speed_basis', 'pre_status_speed_layer_presence', '_ft_prepared_spells_loaded']) delete host[key];
    if (Array.isArray(host.inventory) && host.inventory.length === 0) delete host.inventory;
}
